import type { NextSeoProps } from 'next-seo';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import type { ReactNode } from 'react';
import { baseUrl } from '@/lib/constants';
import ButtonScrollTop from './ButtonScrollTop';
import Footer from './Footer';
import Header from './Header';

type ContainerProps = Omit<NextSeoProps, 'children'> & {
  children: ReactNode;
  blank?: boolean;
  canonical_url?: string;
  image_url?: string;
};
export default function Container({
  children,
  blank = false,
  canonical_url,
  image_url,
  ...props
}: ContainerProps) {
  const { locale, asPath } = useRouter();
  const router = useRouter();

  const canonicalDefault =
    `${baseUrl}` + (router.pathname === '/' ? '' : router.pathname);

  const {
    title,
    description = locale === 'vi'
      ? 'Giao hàng siêu tốc xe máy - xe tải, an toàn, đáp ứng mọi nhu cầu.'
      : 'The ultimate solution for all delivery demands',
    openGraph,
    ...restProps
  } = props;

  const cleanPath = asPath.split('#')[0].split('?')[0];
  const url = `${baseUrl}` + (asPath === '/' ? '' : cleanPath);

  return (
    <>
      <NextSeo
        title={title}
        // titleTemplate={`%s | Ahamove - Chuyên gia giao hàng`}
        defaultTitle="Ahamove - Chuyên gia giao hàng"
        description={description}
        canonical={canonical_url || canonicalDefault}
        openGraph={{
          url,
          type: 'website',
          site_name: process.env.NEXT_PUBLIC_APP_NAME,
          description,
          title: title || 'Ahamove - Chuyên gia giao hàng',
          images: [
            {
              // url: `${
              //   image_url || `${baseUrl}/static/images/banner.jpg`
              //   }?v=${new Date().getTime()}`,
              url: image_url || `${baseUrl}/static/images/banner.jpg`,
              height: 627,
              width: 1200,
              alt: title || 'Ahamove - Chuyên gia giao hàng',
            },
          ],
          ...openGraph,
        }}
        twitter={{
          handle: '@ahamove',
          cardType: 'summary_large_image',
          site: '@ahamove',
        }}
        {...restProps}
      />
      {blank ? null : <Header />}
      {children}
      <ButtonScrollTop />
      {blank ? null : <Footer />}
    </>
  );
}
